import { ConfiguracionCanal } from "@/core/models";


export class ChannelPayInStoreRule {
  /**
   * Evalúa si el canal permite el pago en tienda.
   */
  public static validate(configurationChannel: ConfiguracionCanal | null): boolean {
    if (!configurationChannel) return false;

    return configurationChannel?.configuracion?.payInStore ?? false;
  }
}